module.exports = __webpack_public_path__ + "ef9b8f175aa15eedafa43e32f0754e81.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/Assets/img6.jpeg
// module id = 1332
// module chunks = 0